import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

export const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    enterDelay={100}
    enterTouchDelay={100}
    enterNextDelay={100}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.colors.borderNeutralDarkGray,
    fontSize: 16,
    borderRadius: 8,
    padding: "6px 10px",
    color: `${theme.palette.text.primary} !important`,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.colors.borderNeutralDarkGray,
  },
}));
